/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { call, put, select, take, takeLeading } from 'redux-saga/effects';

import { getSettings } from '@nebula/airglow-plugin-unified-shell';
import { ORG_CHANGE } from '@nebula/airglow-plugin-unified-shell/dist/actions';

import { navigateToSessionList, statefulInit, statefulReset } from '../../common/actions';
import { selectSessionRouteParam } from '../../common/selectors';
import { DEFAULT_VIEW_PLUGINS } from '../data/plugins';
import { getFeatureFlags } from './feature.flags.saga';
import { sessionListSearch } from '../../session-list/data/prefabs';

export function* handleOrgChange() {
  yield put(statefulReset());
  yield put(statefulInit());
  yield call(getFeatureFlags, true);
  yield put(sessionListSearch.resetAction);

  const sessionUuid = yield select(selectSessionRouteParam);
  if (sessionUuid) {
    yield put(navigateToSessionList());
  }

  yield call(getSettings, {
    groupId: 'griffon',
    level: 'org',
    settings: {
      enabledViewPlugins: DEFAULT_VIEW_PLUGINS,
      validationPlugins: {},
      sessionSettings: {}
    }
  });
  yield call(getSettings, {
    groupId: 'griffon',
    level: 'userorg',
    settings: { enabledViewPlugins: [], validationPlugins: {} }
  });
}

// shell fires an org change when initialized
export function* handleFirstOrgChange() {
  while (true) {
    const action = yield take(ORG_CHANGE);
    yield call(handleOrgChange, action);
  }
}

export default function* proxyReadySaga() {
  yield takeLeading(ORG_CHANGE, handleFirstOrgChange);
}
